import { Icon } from '@elotech/components';
import classNames from 'classnames';
import AuthService from 'common/auth/AuthService';
import { alert } from 'common/components';
import keycloakService from 'keycloak/KeycloakService';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';

const OffSidebarLogin = ({ ui, config }) => {
  const history = useHistory();

  const classes = classNames('features-user auto-height', {
    active: ui.offsidebarLoginToggled
  });

  const onLogin = () => {
    if (config.integradoUnico || config.unicoParcial) {
      AuthService.redirectToLogin();
    } else if (config.isCloud) {
      keycloakService.login(() => {
        window.location.href = '/';
      });
    } else {
      history.push('/login');
    }
  };

  const goToOxyCidadao = () => {
    if (!config.urlOxyCidadao) {
      return alert({
        type: 'info',
        title: 'A entidade não possui o Oxy Cidadão configurado!'
      });
    }

    window.location.href = config.urlOxyCidadao;
  };

  return (
    <div className={classes}>
      <h2 className="title">Login</h2>
      <ul className="user-actions">
        <li onClick={goToOxyCidadao}>
          <Icon icon="house-user" className="icon" />
          Cidadão
        </li>

        <li onClick={onLogin}>
          <Icon icon="user-tie" className="icon" />
          Servidor
        </li>
      </ul>
    </div>
  );
};

const mapStateToProps = state => ({
  ui: state.ui,
  config: state.config
});

const connectedComponent = connect(mapStateToProps)(OffSidebarLogin);

export default connectedComponent;
